<script setup lang="ts">
/**
 * The Progress Dots
 * --------------------------------
 * Progress Dots on top right of page (stepper)
 */

const stepsCheckout = [
    {
        routeName: 'checkout-checkout-1-cart',
    },
    {
        routeName: 'checkout-checkout-2-address',
    },
    {
        routeName: 'booking-booking-1-booking',
    },
];

const route = useRoute();

const stepsOfferFlow = computed(() => getProductConfigFromRoute(route)?.steps ?? useCartStore().lastProduct?.config.steps ?? []);
const stepNames = computed(() => [...stepsOfferFlow.value, ...stepsCheckout].map(step => step.routeName));
const totalDots = computed(() => stepNames.value.length);
const currentDot = computed(() => stepNames.value.indexOf(getRouteName(route)) + 1);
const isEnabled = computed(() => stepNames.value.includes(getRouteName(route)));
</script>

<template>
    <ul v-if="isEnabled" class="flex space-x-1">
        <li
            v-for="dot in totalDots"
            :key="dot"
            class="size-[5px] rounded-full transition-[width,background-color] duration-700"
            :class="{
                'w-[30px]': dot === currentDot,
                'bg-shade-5': dot <= currentDot,
                'bg-shade-3': dot > currentDot,
            }"
        />
    </ul>
</template>
